import { render, staticRenderFns } from "./SmsConsent.vue?vue&type=template&id=9dc4f3e6"
import script from "./SmsConsent.vue?vue&type=script&lang=js"
export * from "./SmsConsent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Wampp-latest\\www\\REZOSYSTEMS\\dev-ski-rentals5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9dc4f3e6')) {
      api.createRecord('9dc4f3e6', component.options)
    } else {
      api.reload('9dc4f3e6', component.options)
    }
    module.hot.accept("./SmsConsent.vue?vue&type=template&id=9dc4f3e6", function () {
      api.rerender('9dc4f3e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/dialogs/dialog_sms_consent/SmsConsent.vue"
export default component.exports